import { ElementType } from 'react';
import { css } from '@emotion/react';
import { Colors } from '../common/Colors';
import { Media } from '../types';
import { Variables } from '../common/Variables';
import { getMediaProp, setDeclaration } from '../utils';

export type LevelType = 1 | 2 | 3 | 4;

type ViewType = 'positive' | 'negative' | 'disabled';
type SizeType = 'M' | 'L' | 'XL' | 'XXL' | 'XXXL';
type FontType = 'inherit' | 'primary' | 'second';

export interface TypographyTitleProps {
  as?: ElementType;
  level?: LevelType;
  size?: SizeType | Media<SizeType>;
  view?: ViewType;
  font?: FontType;
  align?: 'left' | 'center' | 'right';
}

const fontSizeList: { [key in SizeType]: string } = {
  M: Variables.typoTextFsM,
  L: Variables.typoTextFsL,
  XL: Variables.typoTextFsXL,
  XXL: Variables.typoTextFsXXL,
  XXXL: Variables.typoTextFsXXXL
};

const lineHeightList: { [key in SizeType]: string | number } = {
  M: Variables.typoTextLhM,
  L: Variables.typoTextLhL,
  XL: Variables.typoTextLhXL,
  XXL: Variables.typoTextLhXXL,
  XXXL: Variables.typoTextLhXXXL
};

const getFontSize = (level: LevelType, size?: SizeType | Media<SizeType>) => {
  if (size) {
    return getMediaProp(size, fontSizeList);
  }

  // при указании level проставляется соотвествующий размер. Легаси код для поддержки старого кода UTEX
  switch (level) {
    case 1:
      return fontSizeList.XXL;
    case 2:
      return fontSizeList.XL;
    case 3:
      return fontSizeList.L;
    default:
      return null;
  }
};

const getLineHeight = (level: LevelType, size?: SizeType | Media<SizeType>) => {
  if (size) {
    return getMediaProp(size, lineHeightList);
  }

  // при указании level проставляется соотвествующий размер. Легаси код для поддержки старого кода UTEX
  switch (level) {
    case 1:
      return lineHeightList.XXL;
    case 2:
      return lineHeightList.XL;
    case 3:
      return lineHeightList.L;
    default:
      return null;
  }
};

const getColorView = (view?: ViewType) => {
  switch (view) {
    case 'positive':
      return Colors.text.primary;

    case 'negative':
      return Colors.text.alert;

    case 'disabled':
      return Colors.text.defaultDim;

    default:
      return null;
  }
};

const getFontFamily = (font?: FontType) => {
  switch (font) {
    case 'primary':
      return "'Inter', 'Arial', sans-serif";

    case 'second':
      return "'Dewi', 'Arial', sans-serif";

    default:
      return null;
  }
};

export const helperTypographyTitle = (props: TypographyTitleProps) => {
  const { view, level = 1, size, font = 'inherit', align } = props;

  return css`
    ${setDeclaration('fontSize', getFontSize(level, size))};
    ${setDeclaration('lineHeight', getLineHeight(level, size))};
    font-family: ${getFontFamily(font)};
    font-weight: 700;
    text-align: ${align};
    color: ${getColorView(view)};
  `;
};
